import { AuthToken, AzureLoginResult, ShopJwtPayload } from '@libs/shared/models';
import * as JwtDecoder from 'jwt-decode';

export function createUserToken(authResult: AzureLoginResult): AuthToken {
  const result: AzureLoginResult = (authResult);

  const token: string = result.idToken;
  const jwt: ShopJwtPayload = JwtDecoder.jwtDecode(token);
  const currentUserId: string = result.accountId ?? String(jwt.sub);
  const userId: string = authResult.type === 'user' ? currentUserId : '';
  const agentId: string = authResult.type === 'llDirectoryUser' ? currentUserId : '';

  return {
    bearer: token,
    userId: userId,
    agentId: agentId,
    expires: Number(jwt.exp) * 1000,
    type: authResult.type,
    roles: jwt.roles,
  };
}
